import { useSearchParams } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { FILTER_OPTIONS, type FilterType } from '@/lib/filters';
import { cn } from '@/lib/utils';

export function FilterDropdown() {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentFilter = (searchParams.get('filter') as FilterType) || undefined;

  const currentOption =
    FILTER_OPTIONS.find((opt) => opt.value === currentFilter) ?? FILTER_OPTIONS[0];

  const handleFilterChange = (value: FilterType) => {
    if (value) {
      setSearchParams({ filter: value });
    } else {
      setSearchParams({});
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="gap-2 font-medium">
          {currentOption.label}
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {FILTER_OPTIONS.map((option) => {
          const Icon = option.icon;
          const isActive = currentFilter === option.value;

          return (
            <DropdownMenuItem
              key={option.label}
              onClick={() => handleFilterChange(option.value)}
              className={cn('gap-3', isActive && 'bg-accent')}
            >
              <Icon className="h-4 w-4" />
              <span>{option.label}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
